module.exports = __webpack_public_path__ + "static/media/contele_tracker.bdc2ec7f.png";